import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { getLogoBase64 } from '../../localStorages';

const CHUNK_SIZE = 500;

const pdfConfig = ({
  data,
  Header,
  title,
  mainHeader,
  fileName,
  fontSize,
  cellPadding,
  isFile,
  lineWidth,
  cellWidth,
}) => {
  const unit = 'pt';
  const size = 'A4'; // Use A1, A2, A3 or A4
  const orientation = 'landscape'; // portrait or landscape
  const doc = jsPDF(orientation, unit, size);
  const headers = Header;
  const logoBase64 = getLogoBase64();
  const didDrawPage = pageData => {
    if (logoBase64) {
      doc.addImage(logoBase64, 'JPEG', pageData.settings.margin.left, 8, 40, 23);
    }
  };
  const sharedStyles = {
    fontSize: fontSize || 6,
    textColor: '#000000',
    cellPadding: cellPadding || 3,
    lineWidth: lineWidth || 0,
    cellWidth,
  };
  const sharedHeadStyles = {
    fillColor: '#00A651',
    textColor: '#ffffff',
  };
  const margin = { left: 5, right: 5, top: 40 };
  const rows = data && data.length ? data : [];

  doc.text(title, 340, 40);

  // For small datasets, render in a single autoTable call (original behavior)
  if (rows.length <= CHUNK_SIZE) {
    doc.autoTable({
      startY: 70,
      head: mainHeader ? [mainHeader, headers] : [headers],
      body: rows,
      margin,
      styles: sharedStyles,
      headStyles: sharedHeadStyles,
      didDrawPage,
    });
  } else {
    // For large datasets, render in chunks to avoid memory overflow.
    // Each autoTable call processes a subset of rows, allowing the browser
    // to GC intermediate state between chunks.
    const totalChunks = Math.ceil(rows.length / CHUNK_SIZE);
    const headRows = mainHeader ? [mainHeader, headers] : [headers];
    for (let i = 0; i < totalChunks; i++) {
      const chunk = rows.slice(i * CHUNK_SIZE, (i + 1) * CHUNK_SIZE);
      const isFirst = i === 0;
      doc.autoTable({
        startY: isFirst ? 70 : doc.lastAutoTable.finalY,
        // Pass head to all chunks so column widths stay consistent.
        // Only render headers for the first chunk to avoid mid-page
        // header rows appearing between chunk boundaries.
        head: headRows,
        showHead: isFirst ? 'everyPage' : 'never',
        body: chunk,
        margin,
        styles: sharedStyles,
        headStyles: sharedHeadStyles,
        didDrawPage,
      });
    }
  }

  if (isFile) {
    const file = doc.output('blob');
    return file;
  }

  doc.save(fileName);
};

export default pdfConfig;
